// @ts-expect-error Untyped module
import tinymce from 'tinymce';
import I18n from 'I18n';
import { TRIGGER } from '../../constants/hscontentgeneration';
import { COLLAB_MODE_INTERACTIONS_TRACKING } from '../constants';
import { trackInteraction } from '../../utils/usageTracking';
import { getCopilotSessionIdFromEditor } from '../../hscontentgeneration/utils';
export function initAutocompletePluginWithSlashCommands(editor, slashCommands) {
  const formattedCommands = slashCommands.map(command => Object.assign({}, command, {
    label: I18n.text(command.labelKey),
    onSelect: () => command.onClick(editor, command, 'slash')
  }));
  const autocompleteConfig = {
    trigger: TRIGGER,
    getFilteredCommands: text => {
      const filteredCommands = formattedCommands.filter(command => command.label.toLowerCase().includes(text.toLowerCase()));
      return filteredCommands;
    }
  };
  editor.on('hsautocomplete:openPopover', () => {
    trackInteraction(editor, COLLAB_MODE_INTERACTIONS_TRACKING,
    // `action` - (will be added to the eventProperties below)
    'menu-opened', {
      interactionType: 'inline-interaction',
      featureCategoryId: 'generate_text',
      sessionId: getCopilotSessionIdFromEditor(editor)
      // inApp: supplied by tinyMCE magic
    });
  });
  tinymce.canvas.addAutocompleteCommand(editor, autocompleteConfig);
}